import getEvertransitCookie from './getEvertransitCookie';

export default function getEvertransitGroupId() {
    const etCookie = getEvertransitCookie();
    return etCookie && etCookie.group;
}
